import ConfigManager from '@/config/ConfigManager.js' 
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators'; 
import { ProfileModel } from '../model/ProfileModel.js';

export default { 
    apiCustomerInfo: function (token) {   
        let url = ConfigManager.getApiModuleUrl() + "/tni/customer_info?device_app_id=" + ConfigManager.getAppId();
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => { 
            let profile = new ProfileModel();
            profile.setValueFromCache(res.data); 
            return profile;
        }));
    },
}
